import {ComponentData} from "../../engine/tools/EntityManager";
import {Pointer} from "../../engine/tools/InputManager";

export class RotationGrabState implements ComponentData {
    startObjectAngle: number
    startInputAngle: number
    pointer: Pointer

    constructor(options?: Partial<RotationGrabState>) {
        Object.assign(this, options)
    }
}